<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="toc"><a id="page_vi"></a><a id="page_vii"></a><span class="small"><strong>CONTENTS</strong></span></h2>
<p class="toc-fm"><a class="nounder" href="#/xhtml/acknowledgments"><em>Acknowledgments</em></a></p>
<p class="toc-fm"><a class="nounder" href="#/xhtml/prologue">Prologue. “Glorious”</a></p>
<p class="toc-part"><a class="nounder" href="#/xhtml/Part1"><span class="small">PART ONE MAKING A SETTLEMENT</span></a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch01">1 Removals</a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch02">2 Seduced</a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">3 Farms without Titles</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">4 “A Very Public Place”</span></p>
<p class="toc-part"><span class="nounder" href="#/xhtml/Part2" title="Link target outside of Sample"><span class="small">PART TWO DISASTER AND PERSISTENCE</span></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">5 “To Begin Again”</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">6 Favorite Son</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">7 Prominent Citizens</span></p>
<p class="toc-part"><span class="nounder" href="#/xhtml/Part3" title="Link target outside of Sample"><span class="small">PART THREE THE SECOND GOLD RUSH</span></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample">8 “As Good As Wheat”</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample">9 “A Devil’s Opportunity”</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch10" title="Link target outside of Sample">10 Looking Back</span></p>
<p class="toc-part"><a id="page_viii"></a><span class="nounder" href="#/xhtml/Part4" title="Link target outside of Sample"><span class="small">PART FOUR THE NEW GENERATION EMERGES</span></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch11" title="Link target outside of Sample">11 Gold—Wheat—Fruit</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch12" title="Link target outside of Sample">12 Legacies</span></p>
<p class="toc-part"><span class="nounder" href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue. Remnants</span></p>
<p class="toc-bm"><span class="nounder" href="#/xhtml/notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-bm"><span class="nounder" href="#/xhtml/essay" title="Link target outside of Sample"><em>Essay on Sources</em></span></p>
<p class="toc-bm"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f4ac7ec0